module.exports = __webpack_public_path__ + "static/media/pollen2.f4ceb3c0.png";